module.exports = __webpack_public_path__ + "media/wav2.6948e0d3.mp4";